import React from 'react'
import UserTab from '../setting/userTabSection/userTab'

const ProfessionalUsers = () => {

    return (
        <div>
            <UserTab type={"professional"}/>
        </div>
    )
}

export default ProfessionalUsers
